// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ecfafec6","239":"0c91af83","455":"1b88cdaf"}[chunkId] + ".chunk.js";
};